export default __webpack_public_path__ + "static/media/mana7.2e339f43.svg";